import React from 'react';
import './Resume.css'

const Resume = () => {
    return (
        <div className='myDiv' id='home' >
            <div className='hero min-h-screen'>
                <div className="hero-content text-center">
                    <div className="m-8 text-xl">
                        <h1 className='text-5xl font-bold'>Hello, I'M MD NAZMUL</h1>
                        <h2>Full stack Developer 💻</h2>
                        <p>
                            The knack for building Web applications with front and back-end operations.
                        </p>
                    </div>
                    <a href="https://drive.google.com/u/0/uc?id=141ANVixo0cOZGijP22UDySvupd2bT_nW&export=download" download="MD.NAZMUL MD-NAZMUL.pdf">
                        <button className="btn btn-outline">Get Resume</button>
                    </a>
                </div>
            </div>
        </div >

    );
};

export default Resume;
